












import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'RecoveryTerms'
})

export default class RecoveryTerms extends Vue {

  created() {
    document.title = '注册条款';
  }
}
